import React from 'react'
import { Button, Box, IconButton, DialogActions, Dialog, useTheme, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Loading from '../Common/Loading'

interface DialogLinksProps {
  open: boolean
  setOpen: (open: boolean) => void
  idContrato: number
  loadingMP: boolean
  loadingTalo: boolean
  handleButtonLink: (id: number, platform: string) => void
  handleCopiarAlias: (id: number) => void
}

const DialogLinks: React.FC<DialogLinksProps> = ({
  open,
  setOpen,
  idContrato,
  loadingMP,
  loadingTalo,
  handleButtonLink,
  handleCopiarAlias
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          display: 'flex',
          width: isMobile ? '90%' : { xs: '90vw', sm: 400 },
          maxWidth: isMobile ? '90%' : '90vw',
          overflowX: 'hidden'
        }
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '10px', paddingTop: '40px' }}>
        <Button variant="contained" onClick={() => handleButtonLink(idContrato, 'mercadopago')} disabled={loadingMP}>
          {loadingMP ? <Loading /> : 'Link MP'}
        </Button>
        <Button variant="contained" onClick={() => handleButtonLink(idContrato, 'talo')} disabled={loadingTalo}>
          {loadingTalo ? <Loading /> : 'Link CVU'}
        </Button>
        <Button variant="contained" onClick={() => handleCopiarAlias(idContrato)} disabled={loadingTalo}>
          {loadingTalo ? <Loading /> : 'Copiar Alias'}
        </Button>
      </Box>
      <DialogActions>
        <IconButton
          edge="end"
          onClick={() => setOpen(false)}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '14px'
          }}
        >
          <CloseIcon />
        </IconButton>
        <Button
          sx={{ display: 'flex', alignSelf: 'left' }}
          variant="outlined"
          onClick={() => setOpen(false)}
          size="small"
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogLinks
